import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';

@Component({
  selector: 'taxihandgo-field',
  templateUrl: './field.component.html',
  styleUrls: ['./field.component.scss']
})
export class FieldComponent implements OnInit {
  private _value: string = "";

  @Input() length: number;
  @Input() auto: boolean;
  @Input() placeholder: string = "";
  @Output() valueChange = new EventEmitter();
  @Output() paste = new EventEmitter();
  @Input() type: string = "text";
  @Input() maxLength: number = -1;

  @ViewChild('input')
  private inputElement: ElementRef;

  items: any;
  width: number;

  public dirty: boolean = false;

  constructor(private element: ElementRef) { }

  ngOnInit() {
    if (this.auto) {
      this.length = this.value ? this.value.length: 1;
      if (this.maxLength > -1 && this.length > this.maxLength) {
        this.length = this.maxLength;
      }
    }
    this.items = new Array(this.length - 1);
    this.width = (this.length + 2) * 10 + 2;
  }

  @Input()
  get value() {
    return this._value;
  }

  set value(value: string) {
    this._value = value;
    if (this.auto) {
      this.length = this.value ? this.value.length: 1;
      if (this.maxLength > -1 && this.length > this.maxLength) {
        this.length = this.maxLength;
      }
      this.items = new Array(this.length - 1);
      this.width = (this.length + 2) * 10 + 2;
    }
    this.inputElement.nativeElement.value = value;
  }

  public updateValue() {
    this._value = this.inputElement.nativeElement.value.trim();
    this.dirty = true;
    this.valueChange.emit(this.value);
  }

  public updateAutoValue() {
    if (!this.auto) {
      return;
    }
    this._value = this.inputElement.nativeElement.value.trim();
    this.dirty = true;
    this.length = this.value ? this.value.length: 1;
    if (this.maxLength > -1 && this.length > this.maxLength) {
      this.length = this.maxLength;
    }
    this.items = new Array(this.length - 1);
    this.width = (this.length + 2) * 10 + 2;
    this.valueChange.emit(this.value);
  }
}



// WEBPACK FOOTER //
// ./src/app/field/field.component.ts